import {
  apiGet,
  type FetchArgsOptions,
  type FetchResponse,
  getApiUrl,
} from "Infrastructure/Api/Api";

// These types mirror the backend DTOs.
// After running `bun run generate-types`, these can be replaced with auto-generated imports.

export enum ActivityEventType {
  ActorCreated = "ActorCreated",
  ActorPriceCategoryChanged = "ActorPriceCategoryChanged",
  PartnerCreated = "PartnerCreated",
  ProjectCreated = "ProjectCreated",
  ProjectCompleted = "ProjectCompleted",
  ProjectClosed = "ProjectClosed",
  JobCompleted = "JobCompleted",
  PartnerCreditTopUp = "PartnerCreditTopUp",
  ActorPayoutApproved = "ActorPayoutApproved",
  ClientCreated = "ClientCreated",
}

export enum ActivityEntityType {
  Actor = "Actor",
  Partner = "Partner",
  Project = "Project",
  Job = "Job",
  Client = "Client",
}

export type ActivityLogListItemDto = {
  activityLogID: string;
  activityEventType: ActivityEventType;
  activityEntityType: ActivityEntityType;
  entityID?: string | null;
  parentEntityID?: string | null;
  note: string;
  userFullName: string;
  dateCreated: string;
};

export type EntityListOfActivityLogListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ActivityLogListItemDto[];
};

type GetActivityLogFetchResponse =
  | FetchResponse<EntityListOfActivityLogListItemDto, 200>
  | FetchResponse<unknown, 401>
  | FetchResponse<unknown, 500>;

export enum ActivityLogSortColumn {
  DateCreated = "DateCreated",
  UserFullName = "UserFullName",
  ActivityEventType = "ActivityEventType",
  Note = "Note",
}

export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}

export const getActivityLog = (
  limit?: number,
  offset?: number,
  activityEventType?: ActivityEventType,
  dateFrom?: string,
  dateTo?: string,
  sortBy?: ActivityLogSortColumn,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetActivityLogFetchResponse> => {
  const queryParams = {
    limit,
    offset,
    activityEventType,
    dateFrom,
    dateTo,
    sortBy,
    sortOrder,
  };
  return apiGet(
    `${getApiUrl()}/api/v1/activity-log`,
    options,
    queryParams,
  ) as Promise<GetActivityLogFetchResponse>;
};
